import React, { useState, useRef, useEffect } from "react";
import { FaBell, FaTrash, FaCheck } from "react-icons/fa";
import { useNotifications } from "./NotificationContext";
import "./NotificationBell.css";

export default function NotificationBell() {
  const { notifications, markAllAsRead, setNotifications } = useNotifications();
  const [open, setOpen] = useState(false);
  //const [showAllModal, setShowAllModal] = useState(false);
  const wrapperRef = useRef(null);
  const modalRef = useRef(null);

  const unreadCount = notifications.filter((n) => !n.is_read).length;

  // ✅ Close dropdown if clicking OUTSIDE (but NOT on modal)
  useEffect(() => {
    const handleClickOutside = (event) => {
      // ✅ Don't close if clicking on modal
      if (modalRef.current && modalRef.current.contains(event.target)) {
        return;
      }

      // Close dropdown if clicking outside the wrapper
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggle = (e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  const handleDelete = (id) => {
    console.log("🗑️ Deleting notification:", id);
    setNotifications(prev =>
      prev.filter(n => n.notification_id !== id)
    );
  };

  const markAsRead = async (id) => {
    console.log("📌 Marking as read:", id);
    try {
      const res = await fetch("https://dshb-deposits.its.uiowa.edu/api/notifications/mark-read", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ notification_id: id })
      });

      if (!res.ok) {
        const errorData = await res.text();
        console.error("❌ Mark read failed:", errorData);
        return;
      }

      // Update local state immediately
      setNotifications(prev =>
        prev.map(n =>
          n.notification_id === id ? { ...n, is_read: 1 } : n
        )
      );

      console.log("✅ Marked as read locally");
    } catch (err) {
      console.error("❌ Failed to mark as read:", err);
    }
  };

  const handleMarkAllRead = async () => {
    console.log("📌 Marking ALL as read");
    await markAllAsRead();
  };

  const visibleNotifications = notifications.filter(n => !n.is_read);

  return (
    <div className="notification-wrapper" ref={wrapperRef}>
      {/* Bell Icon */}
      <div className="bell-container" onClick={handleToggle}>
        <FaBell className="bell-icon" />
        {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
      </div>

      {/* ✅ Dropdown - Only show when NOT showing modal */}
      {open && (
        <div
          className="notification-dropdown"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="notif-header">
            <span>Notifications</span>
            <div>
              <button 
                className="mark-read-btn" 
                onClick={handleMarkAllRead}
              >
                Mark all read
              </button>
              
            </div>
          </div>

          {visibleNotifications.length === 0 && (
            <div className="notif-empty">No new notifications</div>
          )}

          {visibleNotifications.slice(0, 5).map((n) => (
            <div key={n.notification_id} className={`notif-item ${n.is_read ? "read" : ""}`}>
              <div className="notif-content">
                <strong className="notif-title">
                  {n.message ? n.message.substring(0, 60) : "Notification"}
                </strong>
                <small className="notif-time">
                  {n.created_at ? new Date(n.created_at).toLocaleString() : "N/A"}
                </small>
              </div>

              <div className="notif-actions">
                <button
                  className="notif-action-btn"
                  title="Mark as read"
                  onClick={(e) => {
                    e.stopPropagation();
                    markAsRead(n.notification_id);
                  }}
                >
                  <FaCheck />
                </button>
                <button
                  className="notif-action-btn delete-btn"
                  title="Delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete(n.notification_id);
                  }}
                >
                  <FaTrash />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ✅ Modal - Separate from dropdown */}
      {/*
      {showAllModal && (
        <div className="all-notifications-modal" ref={modalRef} onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="all-notif-header">
              <h2>All Notifications</h2>
              <button onClick={() => {
                console.log("Closing modal");
                setShowAllModal(false);
              }}>Close</button>
            </div>
            <div className="all-notif-list">
              {notifications.length === 0 && <p>No notifications</p>}
              {notifications.map((n) => (
                <div
                  key={n.notification_id}
                  className={`notif-item ${n.is_read ? "read" : ""}`}
                >
                  <div className="notif-list-content">
                    <strong>{n.message ? n.message.substring(0, 80) : "Notification"}</strong>
                    <small>{n.created_at ? new Date(n.created_at).toLocaleString() : "N/A"}</small>
                  </div>
                  <div className="notif-list-status">
                    {n.is_read ? <span className="status-read">Read</span> : <span className="status-unread">Unread</span>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}  */}
    </div>
  );
}